<template>
	<section>
		<painel-shell :extra="true">
			<template v-slot:header-left>
				<watch-navigation :patient="patient" />
			</template>
			<template v-slot:header-right>
				<div class="sk-header-padding-right">
					<picker-calendar @change="onChangeDatetime" />
				</div>
			</template>
			<header-patient :patient="patient" subtitle="Dashboard of patient.">
				<router-link v-if="isDashboard" class="sk-header-button" :to="{ name: 'WatchList'}"><i class="sk-icon sk-icon-back"></i>{{ $t('Back to patients') }}</router-link>
				<router-link v-if="!isDashboard" class="sk-header-button" :to="{ name: 'WatchDashboard', watch_id: patient.id }"><i class="sk-icon sk-icon-back"></i>{{ $t('Back to dashboard') }}</router-link>
			</header-patient>
			<router-view :patient="patient" :datetime="datetime" />
		</painel-shell>
	</section>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import HeaderPatient from '@/modules/ui/HeaderPatient'
import PickerCalendar from '@/modules/datetime/PickerCalendar'
import PainelShell from '@/modules/shell/PainelShell'
import WatchNavigation from './WatchNavigation'

export default {
	components: {
		HeaderPatient,
		PainelShell,
		PickerCalendar,
		WatchNavigation
	},
	props: [
		'user_uid',
		'watch_id'
	],
	data() {
		return {
			datetime: {
				year: moment().year(),
				month: moment().month() + 1,
				day: moment().date(),
				hour: 0,
				minute: 0,
			},
			patient: null,
			fullname: 'Patient',
			date: moment().format('YYYY-MM-DD')
		}
	},
	computed: {
		hasData() {
			return this.patient && this.patient.id !== undefined
		},
		isDashboard() {
			return this.$route.name == 'WatchDashboard'
		},
		...mapGetters({
			getPatient: 'PATIENT'
		})
	},
	methods: {
		onChangeDatetime (value, type) {
			this.datetime = value
		}
	},
	created () {
		this.patient = this.getPatient(parseInt(this.watch_id))
	}
}
</script>

<style scoped>
.sk-grid {
	display: grid;
	justify-content: center;
	grid-auto-rows: 320px;
	grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
	grid-gap: 20px;
}
.sk-header-padding-left {
	padding: 0 0 0 40px;
}
.sk-header-padding-right {
	padding: 0 40px 0 0;
}
.sk-header-button {
	text-decoration: none;
	font-weight: 700;
	color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/watch/Watch.vue